<template>
  <div>
    Formulario empleado directo
  </div>
</template>

<script>
  export default {
    name: "FormEmployee1",
  }
</script>

<style lang="css" scoped>

</style>